

import {Component, Vue} from "vue-property-decorator"

@Component({})
export default class HomePageContentBrussel extends Vue {
  name!: "HomePageContentBrussel"

  pathToPics = require.context('@/assets/', false, /\.[svjpn]{2}g$/);

  getPic(name: string): string {
    return this.pathToPics('./'.concat(name))
  }

  openLink(link: string): void {
    window.open(link, "_blank")
  }

}
